import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/facebook-scheduler")({
	beforeLoad: () => {
		throw redirect({ to: "/channels/facebook" });
	},
});
